import { CrudFormType } from "../../../../shared/form/types/FormTypes";
import { useLangLabels } from "../../../../shared/lang/services/useLangLabels";
import { CarrousellActionInterface } from "../../../../shared/react-table/VirtualGrid/types/VirtualGridTypes";
import VirtualGrid from "../../../../shared/react-table/VirtualGrid/VirtualGrid";
import CreateUpdatePLCForm from "../../domain/instrument-plcs/components/CreateUpdatePLCForm";
import { DeletePLCForm } from "../../domain/instrument-plcs/components/DeletePLCForm";
import { usePLCGridModel } from "../../domain/instrument-plcs/lang/usePLCGridModel";
import { useGetAllPLCs } from "../../domain/instrument-plcs/services/plcService";

export const ManagePLCPage = ({ fixedHeight }: { fixedHeight?: number }) => {
  const { lang } = useLangLabels();
  const { data: plcs, isFetching } = useGetAllPLCs();

  const carrousellActions: CarrousellActionInterface = [
    {
      icon: "edit",
      popoverTitle: lang.crudActions.update,
      component: item => (
        <CreateUpdatePLCForm
          item={item}
          actionType={CrudFormType.update}
          isDataUpdated={!isFetching}
        />
      ),
    },
  ];

  return (
    <VirtualGrid
      gridModel={usePLCGridModel()}
      title={lang.instruments.plcs.title.plural}
      fixedHeight={fixedHeight}
      entityName={lang.instruments.plcs.title.plural}
      items={plcs}
      carrousellComponents={carrousellActions}
      headerActions={() => <CreateUpdatePLCForm actionType={CrudFormType.create} />}
      itemActions={item => <DeletePLCForm item={item} />}
    />
  );
};
